import { render, staticRenderFns } from "./ReportHeader.vue?vue&type=template&id=0ce778a8&"
import script from "./ReportHeader.vue?vue&type=script&lang=js&"
export * from "./ReportHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbrown/projects/okinus/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ce778a8')) {
      api.createRecord('0ce778a8', component.options)
    } else {
      api.reload('0ce778a8', component.options)
    }
    module.hot.accept("./ReportHeader.vue?vue&type=template&id=0ce778a8&", function () {
      api.rerender('0ce778a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/fndry-vue/packages/fn-ui/components/report/ReportHeader/ReportHeader.vue"
export default component.exports